/**
 * Which text to show for an API error. The API sends `message` (English) and, for what field
 * workers see, `messageHi` (Hindi). Show the one for the app's language; fall back to the app's
 * own strings when the API sent nothing useful.
 */
import { ApiError, NetworkError } from "./api";

export type Lang = "hi" | "en";

export function pickMessage(e: { message?: string | null; messageHi?: string | null } | null | undefined, lang: Lang): string | null {
  if (!e) return null;
  if (lang === "hi") return e.messageHi || null;
  return e.message || null;
}

/** The API's own words for an error, in the app's language, or null. */
export function apiErrorText(e: unknown, lang: Lang): string | null {
  return e instanceof ApiError ? pickMessage({ message: e.body?.message ?? null, messageHi: e.messageHi ?? null }, lang) : null;
}

export type LoginFailure = "offline" | "wrong" | "disabled" | "too_many" | "invalid" | "server";

export function classifyLoginError(e: unknown): LoginFailure {
  if (e instanceof NetworkError) return "offline";
  if (e instanceof ApiError) {
    if (e.code === "account_disabled") return "disabled";
    if (e.status === 429) return "too_many";
    if (e.status === 400) return "invalid";
    if (e.status === 401) return "wrong";
  }
  return "server";
}

/** Text for a stored outbox error: the API's message in the app's language, else its English message. */
export function outboxErrorText(err: { message: string; messageHi?: string }, lang: Lang): string {
  return pickMessage(err, lang) ?? err.message;
}
